// @ts-nocheck
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Images
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import team5 from "assets/images/team-5.jpg";
import maria from "assets/images/marie.jpg";
import bruceMars from "assets/images/bruce-mars.jpg";
import ivana from "assets/images/ivana-squares.jpg";
import kal from "assets/images/kal-visuals-square.jpg";
import ivanaSquare from "assets/images/ivana-square.jpg";
import ivancik from "assets/images/ivancik.jpg";

const storiesData = [
  {
    image: team1,
    name: "Abbie W",
    color: "info",
  },
  {
    image: team2,
    name: "Boris U",
    color: "info",
  },
  {
    image: team3,
    name: "Kay R",
    color: "info",
  },
  {
    image: team4,
    name: "Tom M",
    color: "info",
  },
  {
    image: team5,
    name: "Nicole N",
    color: "info",
  },
  {
    image: maria,
    name: "Maria P",
    color: "info",
  },
  {
    image: bruceMars,
    name: "Burce M",
    color: "info",
  },
  {
    image: ivana,
    name: "Sandra A",
    color: "secondary",
  },
  {
    image: kal,
    name: "Katty L",
    color: "secondary",
  },
  {
    image: ivanaSquare,
    name: "Emma Q",
    color: "secondary",
  },
  {
    image: ivancik,
    name: "Tao Q",
    color: "secondary",
  },
];

export default storiesData;
